var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-text-field", {
        staticClass: "mb-2",
        attrs: {
          "prepend-inner-icon": "mdi-magnify",
          label: "Buscar módulo ou permissão",
          dense: "",
          outlined: "",
          clearable: "",
          "hide-details": "",
        },
        model: {
          value: _setup.search,
          callback: function ($$v) {
            _setup.search = $$v
          },
          expression: "search",
        },
      }),
      _c("div", { staticClass: "caption grey--text mb-3" }, [
        _vm._v(
          _vm._s(_setup.totalSelected) +
            " de " +
            _vm._s(_setup.totalPermissions) +
            " permissões selecionadas"
        ),
      ]),
      _vm._l(_setup.filteredInstances, function (module) {
        return _c(
          "div",
          { key: module.id, staticClass: "mb-3" },
          [
            _c(
              "v-card",
              { attrs: { outlined: "" } },
              [
                _c(
                  "v-card-title",
                  { staticClass: "py-2" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "", color: "grey darken-1" },
                      },
                      [_vm._v("mdi-shield-key-outline")]
                    ),
                    _c("div", [
                      _c("div", { staticClass: "subtitle-2" }, [
                        _vm._v(_vm._s(module.name)),
                      ]),
                      _c("div", { staticClass: "caption grey--text" }, [
                        _vm._v(_vm._s(module.description)),
                      ]),
                    ]),
                    _c("v-spacer"),
                    _c(
                      "v-chip",
                      {
                        staticClass: "mr-3",
                        attrs: {
                          "x-small": "",
                          label: "",
                          outlined: "",
                          color: _setup.moduleColor(module),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_setup.moduleCount(module)) +
                            "/" +
                            _vm._s(module.permissions.length) +
                            " "
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "caption grey--text mr-2" }, [
                      _vm._v("Todos"),
                    ]),
                    _c("v-switch", {
                      staticClass: "pa-0 ma-0",
                      attrs: {
                        "input-value": _setup.isModuleAll(module),
                        color: "green darken-2",
                        "hide-details": "",
                        dense: "",
                      },
                      on: {
                        change: function ($event) {
                          return _setup.toggleModule(module, $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("v-divider"),
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-row",
                      { attrs: { dense: "" } },
                      _vm._l(module.permissions, function (perm) {
                        return _c(
                          "v-col",
                          { key: perm.id, attrs: { cols: "12", sm: "4" } },
                          [
                            _c("v-checkbox", {
                              staticClass: "mt-0 pt-0 text-capitalize",
                              attrs: {
                                value: perm.id,
                                label: perm.name,
                                color: "green darken-3",
                                "hide-details": "",
                                dense: "",
                              },
                              on: { change: _setup.apply },
                              model: {
                                value: _setup.selected,
                                callback: function ($$v) {
                                  _setup.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      !_setup.filteredInstances.length
        ? _c(
            "div",
            { staticClass: "text-center grey--text py-6" },
            [
              _c("v-icon", { attrs: { color: "grey lighten-1" } }, [
                _vm._v("mdi-magnify-close"),
              ]),
              _c("div", { staticClass: "caption mt-1" }, [
                _vm._v("Nenhum resultado."),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }